"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInputField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _FormControl = require("./FormControl");

var _InputLabel = require("./InputLabel");

var _FormHelperText = require("./FormHelperText");

var _RadioInput = require("./RadioInput");

var _components = require("./components");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  options: _propTypes.any,
  id: _propTypes.string,
  name: _propTypes.string,
  label: _propTypes.string,
  helperText: _propTypes.string,
  value: _propTypes.any,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  error: _propTypes.any,
  success: _propTypes.any,
  warning: _propTypes.any,
  disabled: _propTypes.any,
  FormHelperTextProps: _propTypes.any,
  noOutline: _propTypes.bool,
  fullWidth: _propTypes.bool
} : {};

var RadioInputsWrapper = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), _components.inputGroup);

var RadioInputsWrapperBlock = _stylitas.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), _components.inputGroupBlock);

var RadioInputNoOutline = _stylitas.styled.fieldset(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), _components.radioInputNoOutline);

var fieldset = _stylitas.styled.fieldset(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));

var RadioInputField = /*#__PURE__*/_react.default.forwardRef(function (props, withRef) {
  var options = props.options,
      FormHelperTextProps = props.FormHelperTextProps,
      id = props.id,
      name = props.name,
      label = props.label,
      helperText = props.helperText,
      value = props.value,
      _onChange = props.onChange,
      onBlur = props.onBlur,
      error = props.error,
      success = props.success,
      warning = props.warning,
      disabled = props.disabled,
      noOutline = props.noOutline,
      fullWidth = props.fullWidth,
      inputProps = _objectWithoutProperties(props, ["options", "FormHelperTextProps", "id", "name", "label", "helperText", "value", "onChange", "onBlur", "error", "success", "warning", "disabled", "noOutline", "fullWidth"]);

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;

  var _ref = (0, _react.useState)(value),
      _ref2 = _slicedToArray(_ref, 2),
      optionValue = _ref2[0],
      setChecked = _ref2[1];

  var InputFieldset = noOutline ? RadioInputNoOutline : fieldset;
  var RadiosWrapper = fullWidth ? RadioInputsWrapperBlock : RadioInputsWrapper;
  return (0, _core.jsx)(RadioInputsWrapper, inputProps, (0, _core.jsx)(_FormControl.FormControl, {
    success: success,
    warning: warning,
    disabled: disabled,
    error: error
  }, (0, _core.jsx)(InputFieldset, {
    tabIndex: 0,
    noOutline: noOutline
  }, label && (0, _core.jsx)(_InputLabel.InputLabel, null, label), (0, _core.jsx)(RadiosWrapper, null, options.map(function (option) {
    var optionId = option.id || "".concat(name, "_").concat(option.value);
    return (0, _core.jsx)(_RadioInput.RadioInput, (0, _extends2.default)({
      key: option.value,
      name: name,
      id: optionId,
      value: option.value,
      error: error,
      checked: option.value === optionValue,
      onBlur: onBlur,
      onChange: function onChange(event) {
        setChecked(option.value);

        _onChange(event);
      },
      label: option.text,
      fullWidth: fullWidth,
      ref: withRef
    }, inputProps));
  })), helperText && (0, _core.jsx)(_FormHelperText.FormHelperText, (0, _extends2.default)({
    tabIndex: 0,
    error: error,
    id: helperTextId
  }, FormHelperTextProps), helperText))));
});

exports.RadioInputField = RadioInputField;
process.env.NODE_ENV !== "production" ? RadioInputField.propTypes = propTypes : void 0;